export const APPEND_FEED_ITEMS_PER_BLOCK = 'APPEND_FEED_ITEMS_PER_BLOCK';
export const SET_FEED_ITEMS_PER_BLOCK = 'SET_FEED_ITEMS_PER_BLOCK';
